export interface NavLinkItem {
  name: string;
  path: string;
  children?: NavLinkItem[];
}

const aboutChildren: NavLinkItem[] = [
  { name: "Our Team", path: "/about#our-team" },
];

export const navLinks: NavLinkItem[] = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about", children: aboutChildren },
  { name: "Property Types", path: "/property-types" },
  { name: "Lending", path: "/lending" },
  { name: "Contact Us", path: "/contact" },
];
